'use strict';

import FormController from 'app/controllers/form';

class SalesmanController extends FormController {
  /* @ngInject */
  constructor(SalesmenService, $scope, $mdDialog, $mdToast, $state, $location) {
    let salesman = $scope.$parent.$resolve.salesman;
    super(salesman, 'Vendedor', SalesmenService, null, 'salesmen');

    Object.assign(this, {
      SalesmenService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;
  }
}

export default SalesmanController;
